export default __webpack_public_path__ + "static/media/renee_lim.4d04f1ff.jpg";